<template>
  <section>
    <h1 class="text-h3 mb-4">
      Installation
    </h1>
    <p class="mb-8">
      Steps to setup up the projects with UI Core.
    </p>
    <h2 class="text-h4 mb-4">
      Add UI Core as a submodule
    </h2>
    <p>TBD.</p>
    <h2 class="text-h4 mb-4">
      Add Vuetify preset
    </h2>
    <p>TBD.</p>
    <h2 class="text-h4 mb-4">
      Import SCSS variables
    </h2>
    <p>TBD.</p>
  </section>
</template>

<script>
export default {
  name: 'IntroductionInstallation',
  components: {},
  props: {},
  data: () => ({}),
  computed: {},
  watch: {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
